<template>
  <o-alert
    v-if="duplicateOfEmail > 0 || duplicateOfName > 0"
    show
    variant="warning"
    class="text-sm"
  >
    <p>{{ $t('components.customer.elements.duplicate.info', duplicateOfEmail + duplicateOfName) }}</p>
    <ul class="list-disc ml-2 pl-2">
      <li v-if="duplicateOfName">
        <span class="font-semibold">{{ firstName }} {{ lastName }}</span> ({{ $t('components.customer.elements.duplicate.matches', { count: duplicateOfName }, duplicateOfName) }})
      </li>
      <li v-if="duplicateOfEmail">
        <span class="font-semibold">{{ email }}</span> ({{ $t('components.customer.elements.duplicate.matches', { count: duplicateOfEmail }, duplicateOfEmail) }})
      </li>
    </ul>
  </o-alert>
</template>

<script setup lang="ts">
import debounce from 'lodash/debounce'

import {
  OAlert,
} from '@/components/elements'


interface Props {
  firstName?: string | null
  lastName?: string | null
  email?: string | null
}

const props = withDefaults(defineProps<Props>(), {
  firstName: null,
  lastName: null,
  email: null,
})

const { $api } = useNuxtApp()

const duplicateOfName = ref(0)
const duplicateOfEmail = ref(0)

const checkNameDuplicate = debounce(async () => {
  try {
    if (props.firstName && props.lastName) {
      const filters = {
        firstName: props.firstName,
        lastName: props.lastName,
      }

      const response = await $api.customer.checkDuplicate({ filters })

      duplicateOfName.value = response?.paging?.itemCount || 0
    }
  } catch (e) {
    console.log(e)
  }
}, 800)

const checkEmailDuplicate = debounce(async () => {
  try {
    if (props.email) {
      const filters = {
        email: props.email,
      }

      const response = await $api.customer.checkDuplicate({ filters })

      duplicateOfEmail.value = response?.paging?.itemCount || 0
    }
  } catch (e) {
    console.log(e)
  }
}, 800)

watch(() => props.firstName, () => {
  duplicateOfName.value = 0
  checkNameDuplicate()
}, { immediate: true })

watch(() => props.lastName, () => {
  duplicateOfName.value = 0
  checkNameDuplicate()
}, { immediate: true })

watch(() => props.email, () => {
  duplicateOfEmail.value = 0
  checkEmailDuplicate()
}, { immediate: true })
</script>
